export default __webpack_public_path__ + "static/media/play_shield+pc@2x.56279af8.png";